/** Match the step-level history setting authored in Workflow Manager. */
export const stepHistoryView = (uiFlags: unknown): "timeline" | "grouped" | undefined => {
  if (!uiFlags || typeof uiFlags !== "object" || Array.isArray(uiFlags)) return undefined;
  const setting = (uiFlags as Record<string, unknown>).stepHistory;
  if (!setting || typeof setting !== "object" || Array.isArray(setting)) return undefined;
  const view = (setting as Record<string, unknown>).defaultView;
  return view === "timeline" || view === "grouped" ? view : undefined;
};

/** A direct history panel replaces the older widget placement on the same step. */
export const shouldHideLegacyHistoryWidget = (
  view: ReturnType<typeof stepHistoryView>,
  widgetName: string
): boolean => Boolean(view && widgetName === "stepHistory");
